<template>
    <div>
        <toast></toast>
        <div id="consult_left_content" class="pl-3" v-if="!viewToggle">
            <span class="myBtn" @click='goback()'>Back</span>
        </div>
        <div class="nano centre_content" id="centre_contents" v-if="!this.detailes.is_pay">
            <div class="nano-content p-4" id="divblock">
                <h1 class="col-12 information_article_headline p-0">{{this.detailes.title}}</h1>

                <p class="col-12 information_article_info p-0">
                    <span class="mr-2">{{articleTime}}</span>
                    <span v-if="this.detailes.author && this.detailes.author.length > 0">Author：<span class="mr-2"
                                                                                                      v-for="(value,index) in this.detailes.author">{{value}}</span>
                    </span>
                    <span v-if="this.detailes.source">Sources：{{this.detailes.source}}</span>
                </p>
                <div class="col-12 p-0 video_article_video">
                    <div class="m">
                        <!--<video id="my-video" class="video-js" controls preload="auto" style="width: 100%;" height="400" :poster="this.detailes.thumb" data-setup="{}">-->
                        <!--<source ref="video" type="video/mp4">-->
                        <!--&lt;!&ndash;<p class="vjs-no-js"> To view this video please enable JavaScript, and consider upgrading to a web browser that-->
                        <!--<a href="http://videojs.com/html5-video-support/" target="_blank">supports HTML5 video</a>-->
                        <!--</p>&ndash;&gt;-->
                        <!--</video>-->
                    </div>
                </div>
                <div class="col-12 p-0 viedo_article_details">
                    <h4 class="f16">Video Abstract</h4>
                    <p class="f14" style="text-indent: 2rem;">
                        {{this.detailes.description}}
                    </p>
                </div>
                <span class="f12 d-block mb-2" v-if="this.detailes.editor">Editor：{{this.detailes.editor}}</span>
                <div class="pb-5 w-100 border-top-0 border-right-0 border-left-0"
                     style="border: 1px dashed rgba(232,234,239,1);">
                    <span class="float-left f12 text-black-50"
                          v-if="this.detailes.keyword && this.detailes.keyword.length > 0">Keywords：</span>
                    <span v-for="(value,index) in this.detailes.keyword" class="float-left f12 pl-2 pr-2 ">
                    		<!--<a :href="'/tags/'+ value" class="antistop" target="_blank">{{value}}</a>-->
                        <a @click="xhJumpPDSearchType(value)" class="antistop">{{value
                            }}</a>
                    	</span>
                </div>
                <div class="w-100 viedo_article_share mt-2 mb-5">
                    <!--<div class="col-md-9 col-12 viedo_share_icon p-0">-->
                    <!--<img src="../../../../assets/images/silkRoadBase/weixin.png">-->
                    <!--<img src="../../../../assets/images/silkRoadBase/everyone.png">-->
                    <!--<img src="../../../../assets/images/silkRoadBase/kongjian.png">-->
                    <!--<img src="../../../../assets/images/silkRoadBase/Sina_weibo.png">-->
                    <!--<img src="../../../../assets/images/silkRoadBase/Tencent_weibo.png">-->
                    <!--<img src="../../../../assets/images/silkRoadBase/add_share.png">-->
                    <!--</div>-->
                    <div class="float-right">
                        <a href="javascript:void(0)" v-on:click="digg()" class="rounded-pill f12 mr-3 mybtns"
                           :class="detailes.isDigg?'':'enable'" style="border-radius: 50px;"><i
                                class="fa fa-thumbs-up mr-2"></i>Like<span class="ml-2"></span></a>
                        <a href="javascript:void(0)" v-on:click="like()" class="rounded-pill f12 mybtns"
                           :class="detailes.isCollect?'':'enable'" style="border-radius: 50px;"><i
                                class="fa fa-star mr-2"></i>Favorite</a>
                    </div>
                </div>
                <div class="M-block"></div>
                <div class="card commentList" v-if="sys_comment">
                    <div class="card-body">
                        <div>
                            <textarea class="p-3 w-100 bg-light f14" v-model="content"
                                      placeholder="Say something ..."></textarea>
                        </div>
                        <div class="comment">
                            <a href="javascript:void(0)" class="combtn f15 pl-3 pr-3"
                               @click="sendComment()">Comments</a>
                        </div>
                    </div>
                </div>
                <div class="listTotal" v-if="comment.length > 0 && sys_comment">
                    <span class="totalT">All comments</span>
                    <span class="totalNum">{{comment_total}}</span>
                </div>
                <ul class="lists" v-if="comment.length > 0 && sys_comment">
                    <li v-for="item in comment">
                        <img :src="item.passport.img_url ? item.passport.img_url : '../../../../assets/images/silkRoadBase/nohead.png'"
                             alt=""/>
                        <div>
                            <p><span>{{item.passport.nickname}}</span><span>{{timeDiff(item.create_time)}}</span></p>
                            <p>{{item.content}}</p>
                        </div>
                    </li>
                </ul>
                <!--畅言-->
                <div id="SOHUCS" v-show="cy_comment"></div>
            </div>
        </div>
        <div class="nano centre_content charge_hint" id="centre_contents" v-if="this.detailes.is_pay">
            <div class="centre_content nano-content">
                <div class="card text-center p-3 pb-0">
                    <div class="card-body p-0 mycard">
                        <!--<NoPay :obj="detailes"></NoPay>-->
                        <h5 class="mt-3 mb-3">
                            <img src="../../../../assets/images/silkRoadBase/member.png" class="mr-2"/>
                            VIP exclusive
                        </h5>
                        <h4 class="f20 fn600">Paid subscription</h4>
                        <p class="card-text f15 text-secondary mt-3 mb-3">Buy a VIP membership to enjoy exclusive
                            service of Xinhua Silk Road</p>
                        <a href="/db#/accountSettings/menberCenter" class="btn btn-warning mt-3 text-white">Buy now</a>
                        <p class="mt-5 mb-5">More VIP privileges</p>
                        <div class="d-flex row justify-content-around m-0">
                            <div class="card col-md-4 col-12 p-0">
                                <div class="card-body">
                                    <img src="../../../../assets/images/silkRoadBase/56878730129766812.png"/>
                                    <h5 class="card-title mt-3 mb-3">Analyst service</h5>
                                    <h6 class="card-subtitle mb-2 text-muted">180 overseas branches of Xinhua News
                                        Agency, and chief reporters' observations and interaction with them</h6>
                                </div>
                            </div>
                            <div class="card col-md-4 col-12 p-0">
                                <div class="card-body">
                                    <img src="../../../../assets/images/silkRoadBase/41408370476170076.png"/>
                                    <h5 class="card-title mt-3 mb-3">Consulting service</h5>
                                    <h6 class="card-subtitle mb-2 text-muted">Research trends and achievements of more
                                        than 100 top think tanks and consulting institutions in the world</h6>
                                </div>
                            </div>
                            <div class="card col-md-4 col-12 p-0">
                                <div class="card-body">
                                    <img src="../../../../assets/images/silkRoadBase/507574572099684577.png"/>
                                    <h5 class="card-title mt-3 mb-3">Overseas activities service</h5>
                                    <h6 class="card-subtitle mb-2 text-muted">Latest information inquiry and release of
                                        investment projects home and abroad</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-inline-block w-100 pl-3 pr-3 mt-2"
                     style="line-height: 70px;box-shadow:0px 0px 5px 0px rgba(0,0,0,0.05);">
                    <div class="float-left">
                        <img :src="this.detailes.thumb" v-if="this.detailes.thumb" class="img-fluid"
                             style="width: 45px; height: 45px;"/>
                    </div>
                    <div class="float-left ml-3">
                        <p class="f14 mb-0 titleBreviary pb-2 w-75" style="line-height: 40px;">
                            {{this.detailes.title}}</p>
                        <p class="f12 mb-0 text-black-50" style="line-height: 25px;">Purchase a single article</p>
                    </div>
                    <div class="float-right ml-3">
                        <div>
                            <button class="btn btn-primary f15" data-toggle="modal" data-target="#buyModal"
                                    @click="checkpays('wechat')">单篇购买
                            </button>
                        </div>
                    </div>
                    <div class="float-right">
                        <p class="f15">Amount：{{this.detailes.price}} USD</p>
                    </div>
                </div>

                <div class="modal fade" id="buyModal">
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h4 class="modal-title">Payment</h4>
                                <button type="button" class="close" data-dismiss="modal">&times;</button>
                            </div>

                            <!-- 模态框主体 -->
                            <div class="modal-body">
                                <div class="card border-bottom">
                                    <div class="card-body">
                                        <div class="d-flex w-100" style="">
                                            <div class="">
                                                <img :src="this.detailes.thumb" class="img-fluid"
                                                     style="width: 100px; height: 100px;"/>
                                            </div>
                                            <div class="flex-grow-1 ml-3">
                                                <p class="f15 pb-2">{{this.detailes.title}}</p>
                                                <div class="">
                                                    <p class="f14 float-left mb-0 text-black-50">Purchase a single
                                                        article</p>
                                                    <p class="f22 float-right mb-0 text-secondary">
                                                        Amount：{{this.detailes.price}} USD</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-body">
                                        <div class="w-100">
                                            <div class="text-center mb-2">

                                                <button @click="checkpays('wechat')"
                                                        :class="{checkpay:checkpay=='wechat'}" type="button"
                                                        class="btn f16 mr-5">
                                                    <img src="../../../../assets/images/silkRoadBase/weixinPay.png"
                                                         class="img-fluid mr-2" style="width: 20px; height: 20px;"/>WeChat
                                                    Pay
                                                </button>
                                                <button @click="checkpays('alipay')"
                                                        :class="{checkpay:checkpay=='alipay'}" type="button"
                                                        class="btn f16">
                                                    <img src="../../../../assets/images/silkRoadBase/zhifubaoPay.png"
                                                         class="img-fluid mr-2" style="width: 20px; height: 20px;"/>Alipay
                                                </button>
                                            </div>
                                            <div class="text-center" v-show="checkpay==='wechat'">
                                                <div id="payQrcode"
                                                     style="width:150px;height: 150px;margin: 5px auto;"></div>
                                                <p class="f16">
                                                    <img src="../../../../assets/images/silkRoadBase/weixinPay.png"
                                                         class="img-fluid mr-2" style="width: 20px; height: 20px;"/>
                                                    WeChat Pay, {{this.detailes.price}} USD

                                                </p>
                                            </div>
                                            <div class="text-center" v-show="checkpay==='alipay'">
                                                <p>
                                                    <!--<img src="../../../../assets/images/silkRoadBase/二维码.gif" class="img-fluid" />-->
                                                </p>
                                                <p class="f16">

                                                    <img src="../../../../assets/images/silkRoadBase/zhifubaoPay.png"
                                                         class="img-fluid mr-2" style="width: 20px; height: 20px;"/>
                                                    Alipay, {{this.detailes.price}} USD
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import tollHint from '../TollHint/TollHint.vue'
import toast from '../toast/Toast.vue'
import QRCode from 'qrcodejs2'
import NoPay from './../noPay'
import {initCyComment} from '../ChangYanComment.js'
import MixinsXhJumpPd from '@/views/search/mixin/xhJumpPd'

export default ({
  name: 'videoArticle',
  mixins: [MixinsXhJumpPd],
  data: function () {
    return {
      comment: [],
      sys_comment: false, // 是否显示评论
      cy_comment: false, // 是否使用畅言评论
      is_all_audit: false, // 是否全部审核
      content: '',
      comment_total: 0,
      page: 1,
      page_size: 20,
      total_page: 1,
      probationes: [],
      detailes: [],
      bases: toast.apiUrl,
      viewToggle: true,
      clickToggle: true,
      checkpay: '',
      out_trade_no: '',
      timer: null
    }
  },
  created: function () {
    this.clickToggle = false
    this.viewToggle = this.IsPC()
    let that = this
    this.$axios.post('/api/pc/getarticledetail', {
      id: that.$route.params.contentid
    }).then(response => {
      if (response.data.state) {
        that.detailes = response.data.data
        var html = '<video id="my-video" class="video-js vjs-fluid" controls preload="auto"  poster="' + that.detailes.thumb + '" data-setup="{}"><source src="' + that.detailes.content + '" type="video/mp4"></video>'
        $('.m').html(html)
        that.statistics()
      } else {
        $('.wrap').text(response.data.error)
        $('.wrap').show().delay(1500).hide(100)
      }

    })
    this.getComment()
  },
  mounted () {
    this.$nextTick(function () {
      this.load()
    })
  },
  computed: {
    articleTime () {
      if (this.detailes.up_line_time) {
        const date = new Date(this.detailes.up_line_time * 1000)
        const Y = date.getFullYear() + '-'
        const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
        const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate())
       const s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
        const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes())
        const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours())
        return Y + M + D  + ' ' + h + ':' + m + ':' + s
      }
      return this.detailes.published || ''
    }
  },
  methods: {
    digg () {
      this.$axios.post('/api/pc/articledigg', {
        id: this.$route.params.contentid

      }).then(response => {
        if (response.data.state) {
          this.detailes.isDigg = !this.detailes.isDigg
        } else {
          $('.wrap').text(response.data.error)
          $('.wrap').show().delay(1500).hide(100)
        }

      })
    },
    like () {
      this.$axios.post('/api/pc/collectcontent', {
        id: this.$route.params.contentid
      }).then(response => {
        if (response.data.state) {
          this.detailes.isCollect = !this.detailes.isCollect
        } else {
          $('.wrap').text(response.data.error)
          $('.wrap').show().delay(1500).hide(100)
        }

      })
    },
    sendComment () {
      if (!this.content) {
        $('.wrap').text('Comments should not be empty')
        $('.wrap').show().delay(1500).hide(100)
        return
      }
      this.$axios.post('/api/pc/commentreply', {
        content_id: this.$route.params.contentid,
        appid: this.detailes.appid,
        reply_id: 0,
        content: this.content

      }).then(response => {
        if (response.data.state) {
          this.content = ''
          this.getComment()
          if (this.is_all_audit) {
            $('.wrap').text('The comments you submitted have been successful. Please wait for the administrator to review them.')
            $('.wrap').show().delay(1500).hide(100)
          }
        } else {
          $('.wrap').text(response.data.error)
          $('.wrap').show().delay(1500).hide(100)
        }

      })

    },
    getComment () {
      var that = this
      this.$axios.post('/api/pc/commentlist', {
        content_id: this.$route.params.contentid,
        page: this.page,
        pagesize: this.page_size
      }).then(response => {
        if (response.data.state) {
          that.comment = response.data.data.data ? response.data.data.data : []
          that.comment_total = response.data.data.cmt_sum
          that.sys_comment = response.data.data.system_comment_status
          that.is_all_audit = response.data.data.is_all_audit

          if (response.data.data.cy_comment_status) {
            that.cy_comment = true
            initCyComment(response.data.data.cy_comment_status.cyanCommentsCyappid, response.data.data.cy_comment_status.cyanCommentsCyappkey)
          }
        } else {
          $('.wrap').text(response.data.error)
          $('.wrap').show().delay(1500).hide(100)
        }

      })

    },
    timeDiff (published) {
      var now = new Date()
      var date3 = now.getTime() - (published * 1000)

      // 计算相差年数
      var years = Math.floor(date3 / (356 * 24 * 3600 * 1000))
      var mouths = Math.floor(date3 / (30 * 24 * 3600 * 1000))
      //计算出相差天数
      var days = Math.floor(date3 / (24 * 3600 * 1000))
      //计算出小时数
      var hours = Math.floor(date3 / (3600 * 1000))
      //计算相差分钟数
      var minutes = Math.floor(date3 / (60 * 1000))
      // 计算相差秒数
      var seconds = Math.floor(date3 / 1000)

      if (years > 0) {
        if (years == 1) {
          return years + 'year ago'
        }
        return years + 'years ago'
      }

      if (mouths > 0) {
        if (mouths == 1) {
          return mouths + 'month ago'
        }
        return mouths + 'months ago'
      }

      if (days > 0) {
        if (days == 1) {
          return days + 'day ago'
        }
        return days + 'days ago'
      }

      if (hours > 0) {
        if (hours == 1) {
          return hours + 'hour ago'
        }
        return hours + 'hours ago'
      }

      if (minutes > 0) {
        if (minutes == 1) {
          return minutes + 'minute ago'
        }
        return minutes + 'minutes ago'
      }
      if (seconds > 0) {
        if (seconds == 1) {
          return seconds + 'second ago'
        }
        return seconds + 'seconds ago'
      }
    },
    goback () {
      this.$parent.goback()
    },
    checkpays: function (index) {
      if (this.checkpay != index) {
        this.checkpay = index
        this.pay()
      }
    },
    pay: function () {
      var self = this
      this.$axios.post('/api/pc/pay', {
        order_type: 'article',
        pay_type: this.checkpay,
        product_id: this.$route.params.contentid,
        origin_url: window.location.href
      }).then(response => {
        if (this.checkpay == 'alipay') {
          if (response.data.state) {
            $('#buyModal').append(response.data.data.content)
          }
        }
        if (this.checkpay == 'wechat') {
          if (response.data.state) {
            self.out_trade_no = response.data.data.out_trade_no
            document.getElementById('payQrcode').innerHTML = ''
            new QRCode('payQrcode', {
              width: 150,
              height: 150, // 高度  [图片上传失败...
              text: response.data.data.content// 二维码内容
              // render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
              // background: '#f0f'
              // foreground: '#ff0'
            })
            // 两秒之后执行轮训
            setTimeout(this.checkPayResult, 2000)
          }
        }

      })
    },
    // 检查订单状态
    checkPayResult: function () {
      clearInterval(this.timer)
      if (this.checkpay == 'wechat') {
        this.timer = setInterval(() => {
          this.$axios.post('/api/pc/payresult', {
            out_trade_no: this.out_trade_no
          }).then(response => {
            if (response.data.data.state == 6) {
              $('.wrap').text('Successful payment！')
              $('.wrap').show().delay(1500).hide(100)
              clearInterval(this.timer)

              // 关闭弹框
              $('#buyModal').modal('hide')

              // 重新获取右侧文章
              let that = this
              this.$axios.post('/api/pc/getarticledetail', {
                id: this.$route.params.contentid
              }).then(response => {
                if (response.data.state) {
                  that.$parent.clickToggles()
                  that.detailes = response.data.data
                  var html = '<video id="my-video" class="video-js vjs-fluid" controls preload="auto" style="width: 100%" poster="' + that.detailes.thumb + '" data-setup="{}"><source src="' + that.detailes.content + '" type="video/mp4"></video>'
                  $('.m').html(html)
                } else {
                  $('.wrap').text(response.data.error)
                  $('.wrap').show().delay(1500).hide(100)
                }

              })
            }
          })

        }, 1000)
      }
    },
    // 统计
    statistics: function () {
      document.getElementById('staticData').remove()
      var s = document.createElement('script')
      s.type = 'text/javascript'
      s.id = 'staticData'
      s.innerHTML = '_paq.push([\'eventBrowse\', ' + this.detailes.id + ', {\'title\': \'' + this.detailes.title + '\',\'catName\': \'' + this.detailes.category_name + '\'}, 1]);_paq.push([\'eventCustom\', \'CAT\', {\'catName\': \'' + this.detailes.category_name + '\'}, 1]);_paq.push([\'trackPageView\']);'
      document.getElementsByTagName('head')[0].appendChild(s)
    }
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        let that = this
        this.$axios.post('/api/pc/getarticledetail', {
          id: that.$route.params.contentid
        }).then(response => {
          if (response.data.state) {
            if (val.path.indexOf(oldVal.path) < 0) {
              that.$parent.clickToggles()
            }
            that.detailes = response.data.data
            var html = '<video id="my-video" class="video-js vjs-fluid" controls preload="auto" style="width: 100%;" poster="' + that.detailes.thumb + '" data-setup="{}"><source src="' + that.detailes.content + '" type="video/mp4"></video>'
            $('.m').html(html)
            that.statistics()
            that.getComment()
          } else {
            $('.wrap').text(response.data.error)
            $('.wrap').show().delay(1500).hide(100)
          }

        })

      },
      deep: true
    }
  },
  components: {
    tollHint,
    toast,
    NoPay
  }
})
</script>
<style scoped>
    .myBtn {
        width: 60px;
        height: 30px;
        display: block;
        position: absolute;
        top: 20px;
        right: 20px;
        font-size: 12px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(133, 144, 166, 1);
        line-height: 30px;
        text-align: center;
        background: rgba(242, 243, 244, 1);
        border-radius: 20px;
    }

    .myBtn:hover {
        cursor: pointer;
    }

    #consult_left_content {
        height: 65px;

    }

    @media screen and (max-width: 600px) {
        #consult_left_content {
            height: 50px;
            background: white;
        }

        .mycard > h5 {
            margin-top: 10px !important;
        }
    }

    /*评论start*/
    .lists {
        padding: 0
    }

    .lists li {
        padding: 30px 0;
        display: flex;
        justify-content: flex-start;
        border-bottom: 1px solid #EBEBEB;
    }

    .lists li img {
        width: 48px;
        height: 48px;
        border-radius: 50%;
        margin-right: 17px;
        vertical-align: middle;
    }

    .lists li div p:nth-child(1) span:nth-child(1) {
        font-size: 14px;
        font-family: PingFangSC-Medium;
        font-weight: 600;
        margin-right: 30px;
        color: rgba(38, 38, 38, 1);
        line-height: 20px;
    }

    .lists li div p:nth-child(1) span:nth-child(2) {
        font-size: 12px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(89, 89, 89, 1);
        line-height: 17px;
    }

    .lists li div p:nth-child(2) {
        font-size: 14px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(89, 89, 89, 1);
        line-height: 20px;
        margin-bottom: 0;
    }

    .listTotal {
        margin-top: 20px;
    }

    .totalT {
        font-size: 15px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(38, 38, 38, 1);
        line-height: 21px;
    }

    .totalNum {
        font-size: 15px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        line-height: 21px;
    }

    .combtn {
        padding: 8px 35px;
        background: rgba(32, 142, 255, 1);
        border-radius: 2px;
        font-size: 15px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        line-height: 21px;
        display: block;
        width: 100px;
        float: right;
        text-align: center;
    }

    .commentList {
        border: none;
        margin-left: -24px;
        margin-right: -24px;
        border-bottom: 1px solid #EBEBEB
    }

    .commentList textarea {
        border: 1px solid #D9D9D9;
    }

    .comment {
        text-align: right;
        margin-top: 15px;
    }

    button {
        outline: none !important;
        filter: chroma(color=#000000);
    }

    .discomment {
        pointer-events: none;
        cursor: default;
        background: rgba(238, 238, 238, 1) !important;
        border: 1px solid #EEEEEE !important;
        color: #C1C1C1 !important;
    }

    .enable {
        /*pointer-events: none;*/
        /*cursor: default;*/
        background: rgba(255, 255, 255, 1) !important;
        border: 1px solid rgba(217, 217, 217, 1) !important;
        color: #595959 !important;
    }

    button:focus {
        outline: 0;
    }

    .comment button {
        width: 100px;
        height: 36px;
        background: rgba(32, 142, 255, 1);
        border-radius: 2px;
        font-size: 15px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        line-height: 15px;
        text-align: center;
    }

    .mybtns {
        background: rgba(255, 255, 255, 1);
        border-radius: 16px;
        border: 1px solid rgba(32, 142, 255, 1);
        color: rgba(32, 142, 255, 1);
        display: inline-block;
        font-weight: 400;
        text-align: center;
        vertical-align: middle;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        padding: .375rem .75rem;
        font-size: 1rem;
        line-height: 1.5;
        border-radius: .25rem;
    }

    .M-block {
        height: 15px;
        background-color: #F5F6F7;
        margin-left: -24px;
        margin-right: -24px;
    }

    /*评论end*/
    .myBtn {
        width: 60px;
        height: 30px;
        display: block;
        position: absolute;
        top: 20px;
        right: 20px;
        font-size: 12px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(133, 144, 166, 1);
        line-height: 30px;
        text-align: center;
        background: rgba(242, 243, 244, 1);
        border-radius: 20px;
    }

    .myBtn:hover {
        cursor: pointer;
    }

    #consult_left_content {
        height: 65px;
    }

    .modal-dialog {
        max-width: 600px;
    }

    .card-subtitle {
        font-size: 12px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(133, 144, 166, 1);
        line-height: 20px;
    }

    .kaitong {
        background-color: #FEB133;
        border-color: #FEB133;
    }

    .mycard {
        padding-bottom: 110px !important;
    }

    .myfix {
        position: absolute;
        bottom: 0;
        left: 0;
        padding-top: 10px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px -2px 5px 0px rgba(0, 0, 0, 0.05);
    }

    .desp {
        overflow: hidden;
        text-overflow: ellipsis;
        margin-bottom: 22px;
        white-space: nowrap;
        font-size: 13px;
        height: 30px;
        max-width: 400px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(133, 144, 166, 1);
        line-height: 30px;
    }

    .myfont {
        margin-bottom: 0;
    }

    .mcur {
        line-height: 18px;
    }

    .abc {
        display: flex;
        justify-content: space-between;
    }

    @media screen and (max-width: 600px) {
        #consult_left_content {
            height: 50px;
        }

        .myfix {
            position: fixed;
        }

        #divblock {
            padding-top: 0 !important;
        }

        .abc {
            display: block !important;
            text-align: center;
        }

        .abc > div {
            width: auto;
            margin-top: 15px;
        }

        .mycard > h5 {
            margin-top: 10px !important;
        }

        .mybtn:nth-child(1) {
            margin-right: 0 !important;
        }

        .card-body {
            padding: .5rem 0;
        }

        .desp {
            margin-bottom: 10px;
        }

        .mt-40 {
            margin-top: 30px;
        }

        .aaas {
            display: block;
        }

        .myfont {
            height: auto;
        }
    }
</style>
